import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useAuth } from '~/hooks';
import ContactCreateForm from './ContactCreateForm';
import ContactsListPage from './ContactsListPage';
import ContactArea from './ContactArea';

export default function ContactsArea() {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const auth = useAuth();

  const handleCreate = (contact) => {
    history.push(`${url}/${contact.id}/overview/edit`);
  };

  return (
    <>
      <Switch>
        <Route path={[`${path}/`, `${path}/new`, `${path}/edit/:contactId`]} exact>
          <ContactsListPage sessionKey="contacts_list" />
        </Route>
        <Route path={`${path}/:contactId`}>
          <ContactArea />
        </Route>
      </Switch>
      <Route path={`${path}/new`}>
        {auth.contacts.create ? (
          <ContactCreateForm
            onSaved={handleCreate}
            onClose={() => {
              history.push({ pathname: url, search: location.search });
            }}
          />
        ) : (
          <Redirect to={{ pathname: url, search: location.search }} />
        )}
      </Route>
    </>
  );
}
